import React, { useEffect } from "react";
import { t } from "i18next";
import { useSelector } from "react-redux";

import InstallPwa from "@components/InstallPwa/InstallPwa";
import { BANNER_IMAGE } from "@constants/assets";
import { usePwa } from "@hooks/usePwa/usePwa";
import { BannerProps } from "@models/components/organisation.model";
import { RootState } from "@store/index";

const HomeBanner: React.FC<BannerProps> = ({ imageUrl = BANNER_IMAGE }) => {
  const { isPwaSupport, showPWA } = useSelector(
    (State: RootState) => State.local
  );

  const { checkPwaInstalled } = usePwa();

  useEffect(() => {
    checkPwaInstalled();

    return () => {
      window.removeEventListener("appinstalled", () => {});
      window.removeEventListener("beforeinstallprompt", () => {});
    };
  }, []);

  return (
    <div className="fg-banner-block">
      <div className="fg-banner-inner" data-testid="banner-image">
        <img src={imageUrl} alt="" />
        <h1 className="fg-banner-heading" data-testid="banner-image-heading">
          {t("bannerHeading")}
        </h1>

        {showPWA && isPwaSupport && (
          <div
            className="container fg-pwa-install-wrapper"
            data-testid="banner-button-container"
          >
            <InstallPwa />
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeBanner;
